const monthsOfYearShort = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'June',
  'July',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];
export function formatAMPM(inputDate: string | Date) {
  const date = new Date(inputDate);
  let hours = date.getHours();
  let minutes: string | number = date.getMinutes();
  const ampm = hours >= 12 ? 'P.M.' : 'A.M.';
  hours %= 12;
  hours = hours || 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  const strTime = `${hours}:${minutes} ${ampm}`;
  return strTime;
}

export function formatDateOnly(inputDate: string | Date) {
  const date = new Date(inputDate);
  const day = date.getDate();
  // This prints it 16.07.2020
  // let month = ("0" + (date.getMonth() + 1)).slice(-2);
  // This prints it July 16th, 2020
  const month = monthsOfYearShort[date.getMonth()];
  const year = date.getFullYear();
  const strTime = `${month} ${day} ${year}`;
  return strTime;
}

export function formatFullDate(inputDate: string | Date) {
  const date = new Date(inputDate);
  const dateStr = formatDateOnly(date);
  const timeStr = formatAMPM(date);
  return `${dateStr} ${timeStr}`;
}

/**
  Get the minutes apart from two date times
  @param  {Date}  fromDate
  @param  {Date}  toDate
  @returns  {Int} Total minutes apart
*/
export function getMinutesApart(fromDate: Date, toDate: Date) {
  let diff = (toDate.getTime() - fromDate.getTime()) / 1000;
  diff /= 60;
  return Math.round(diff);
}

const isRealDate = (v: unknown): v is string | number | Date =>
  !!v && v !== 'TBD' && !Number.isNaN(new Date(v as any).getTime());

const calcRuntimeSeconds = (job: { startedOn?: any; finishedOn?: any; runtime?: any }) => {
  // If job.runtime exists, use it (coerce if it's a string)
  const provided = Number(job.runtime);
  if (Number.isFinite(provided) && provided > 0) return provided;

  if (!isRealDate(job.startedOn) || !isRealDate(job.finishedOn)) return null;

  const startMs = new Date(job.startedOn).getTime();
  const endMs = new Date(job.finishedOn).getTime();

  if (!Number.isFinite(startMs) || !Number.isFinite(endMs) || endMs < startMs) return null;

  // seconds, rounded down (or use Math.round if you prefer)
  return Math.floor((endMs - startMs) / 1000);
};


const dateTimeUtils = {
  calcRuntimeSeconds,
  formatFullDate,
  formatAMPM,
  formatDateOnly,
  getMinutesApart,
};

export default dateTimeUtils;
